export default "__VITE_ASSET__DYDluRwD__"